import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/app.config';
import { HelpersService, ServiceRequestService } from 'src/app/services';

@Component({
  selector: 'app-workshop-jobcard-service-waivers',
  templateUrl: './workshop-jobcard-service-waivers.component.html',
  styleUrls: ['./workshop-jobcard-service-waivers.component.scss']
})
export class WorkshopJobcardServiceWaiversComponent {

  @Input() jobcard: any = {};

  public waivers: any = [];
  public selectedTab: string = "";
  public loadingWaiver: boolean = false;
  public preServiceWaiver: any = null;
  public postServiceWaiver: any = null;
  public waiverConfig: any = null;

  public preServiceWaiverURL: any = "";
  public postServiceCustomerWaiverURL: any = "";
  public postServiceTechnicianWaiverURL: any = "";
  public postServiceManagerWaiverURL: any = "";
  public preServiceWaiverURLSafe: any = "";
  public postServiceCustomerWaiverURLSafe: any = "";
  public postServiceTechnicianWaiverURLSafe: any = "";
  public postServiceManagerWaiverURLSafe: any = "";

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private helpersService: HelpersService,
    private appConfig: AppConfig,
    private serviceRequest: ServiceRequestService,
    private sanitizer: DomSanitizer,
  ) { }


  ngOnInit() {
    this.getJobCardWaiver();
  }

  getJobCardWaiver() {
    this.loadingWaiver = true;
    this.serviceRequest.getJobCardWaiver(this.jobcard.partnerID, this.jobcard.id, this.jobcard.isFitting).subscribe((waivers: any) => {
      this.waiverConfig = waivers.waiverConfig;


      if (((this.jobcard.IsFitting && this.waiverConfig.preFittingWaiverRequired) || (!this.jobcard.IsFitting && this.waiverConfig.preServiceWaiverRequired) || (waivers.preServiceWaiver && waivers.preServiceWaiver.signatureURL)) && waivers.preServiceWaiver) {
        this.waivers.push({ tab: "PREWAIVER", label: this.jobcard.IsFitting ? 'bikeshop.plugins.widget.pre_fitting_waivers' : 'bikeshop.plugins.widget.pre_workshop_waivers' });
        this.selectedTab = "PREWAIVER";
        this.preServiceWaiverURL = this.appConfig.getWorkshopWidgetURL() + "/waivers/pre-service?waiverIdentifier=" + waivers.preServiceWaiver.webIdentifier + (this.appConfig.isDev() ? "&dev=true" : "");
        this.preServiceWaiverURLSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.appConfig.getWorkshopWidgetURL() + "/waivers/pre-service?waiverIdentifier=" + waivers.preServiceWaiver.webIdentifier + (this.appConfig.isDev() ? "&dev=true" : ""));
      }
      if (((this.jobcard.IsFitting && this.waiverConfig.postFittingWaiverRequired) || (!this.jobcard.IsFitting && this.waiverConfig.postServiceWaiverRequired) || (waivers.postServiceWaiver && waivers.postServiceWaiver.signatureURL)) && waivers.postServiceWaiver) {
        this.waivers.push({ tab: "POSTWAIVER", label: this.jobcard.IsFitting ? 'bikeshop.plugins.widget.post_fitting_waivers' : 'bikeshop.plugins.widget.post_workshop_waivers' });
        if (!waivers.preServiceWaiver) {
          this.selectedTab = "POSTWAIVER";
        }
        this.postServiceCustomerWaiverURL = this.appConfig.getWorkshopWidgetURL() + "/waivers/post-service?waiverIdentifier=" + waivers.postServiceWaiver.webIdentifier + "&waiverType=1" + (this.appConfig.isDev() ? "&dev=true" : "");
        this.postServiceTechnicianWaiverURL = this.appConfig.getWorkshopWidgetURL() + "/waivers/post-service?waiverIdentifier=" + waivers.postServiceWaiver.webIdentifier + "&waiverType=2" + (this.appConfig.isDev() ? "&dev=true" : "");
        this.postServiceManagerWaiverURL = this.appConfig.getWorkshopWidgetURL() + "/waivers/post-service?waiverIdentifier=" + waivers.postServiceWaiver.webIdentifier + "&waiverType=3" + (this.appConfig.isDev() ? "&dev=true" : "");
        this.postServiceCustomerWaiverURLSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.appConfig.getWorkshopWidgetURL() + "/waivers/post-service?waiverIdentifier=" + waivers.postServiceWaiver.webIdentifier + "&waiverType=1" + (this.appConfig.isDev() ? "&dev=true" : ""));
        this.postServiceTechnicianWaiverURLSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.appConfig.getWorkshopWidgetURL() + "/waivers/post-service?waiverIdentifier=" + waivers.postServiceWaiver.webIdentifier + "&waiverType=2" + (this.appConfig.isDev() ? "&dev=true" : ""));
        this.postServiceManagerWaiverURLSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.appConfig.getWorkshopWidgetURL() + "/waivers/post-service?waiverIdentifier=" + waivers.postServiceWaiver.webIdentifier + "&waiverType=3" + (this.appConfig.isDev() ? "&dev=true" : ""));
      }
      this.preServiceWaiver = waivers.preServiceWaiver;
      this.postServiceWaiver = waivers.postServiceWaiver;
      this.loadingWaiver = false;

    });
  }
}
